import React from 'react';
import styles from './Table.module.scss';
import { TableHeader } from './TableHeader.component';
import classnames from 'classnames';
import { TableBody } from './TableBody.component';
export const TableComponent = ({
  data = [],
  columns,
  onSortClick,
  sortedBy,
  reverseSort,
  className,
  onRowClick,
}) => {
  const handleSortClick = (id) => {
    if (!onSortClick) return;
    if (id === sortedBy) {
      onSortClick(id, !reverseSort);
      return;
    }
    onSortClick(id, false);
  };
  return (
    <div className={classnames(styles.table, className, {})}>
      <table>
        <thead>
          <tr>
            {columns.map((column) => (
              <TableHeader
                key={column.id}
                column={column}
                sortedBy={sortedBy}
                reverseSort={reverseSort}
                handleSortClick={handleSortClick}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((row, rowIndex) => {
            return (
              <tr
                key={rowIndex}
                onClick={() => onRowClick?.(row)}
                className={classnames({
                  [styles.clickableTableRow]: onRowClick,
                })}
              >
                {columns.map((column) => {
                  return (
                    <TableBody
                      key={column.id}
                      row={row}
                      rowIndex={rowIndex}
                      column={column}
                    />
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
